<template>
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <b-form class="admin-form" @submit.stop.prevent="submitTaskTemplateCollection">
          <b-form-group horizontal label="Name">
            <b-form-input type="text" v-model="taskTemplateCollectionObject.name"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Team">
            <b-form-select type="" v-model="taskTemplateCollectionObject.team_id" :options="teams"></b-form-select>
          </b-form-group>
          <b-button type="submit" variant="primary">{{submitText}}</b-button>
          <b-button v-if="collection" variant="info" @click="cloneCollection" v-b-tooltip.hover title="Clone"><fa icon="clone" /></b-button>
          <b-button variant="danger" @click="deleteCollection">Delete</b-button>
          <b-alert :show="showError" variant="danger">{{errorMessage}}</b-alert>
        </b-form>
      </div>
    </b-row>
    <TaskTemplates :task_templates="taskTemplateCollectionObject.task_templates" :task_template_collection="taskTemplateCollectionObject"/>
  </div>
</template>

<script>
import TaskTemplates from './TaskTemplates'
export default {
  name: 'TaskTemplateCollection',
  props: {
    collection: Object,
    new_collection: Boolean
  },
  data () {
    return {
      teams: [],
      taskTemplateCollectionObject: {},
      submitText: 'Submit',
      errorMessage: '',
      showError: false
    }
  },
  created () {
    this.getTeams()
    this.getCollection()
  },
  watch: {
    collection: function () {
      this.getCollection()
    },
    new_collection: function () {
      if (this.new_collection) {
        this.taskTemplateCollectionObject = {
          name: '',
          team_id: null
        }
        this.submitText = 'Submit'
        this.errorMessage = ''
      }
    },
    errorMessage: function () {
      if (this.errorMessage.length > 0) {
        this.showError = true
      } else {
        this.showError = false
      }
    }
  },
  mounted () {
    this.$root.$on('taskTemplateWasAdded', () => {
      this.getCollection()
    })
    this.$root.$on('taskTemplateWasDeleted', () => {
      this.getCollection()
    })
  },
  components: {
    TaskTemplates
  },
  methods: {
    getCollection () {
      if (this.collection.value) {
        var vm = this
        this.$http.get('/task_template_collections/' + this.collection.value)
          .then(function (response) {
            vm.taskTemplateCollectionObject = response.data
            vm.submitText = 'Submit'
            vm.errorMessage = ''
          })
          .catch(e => { console.log(e.response) })
      }
    },
    deleteCollection () {
      var del = confirm('Are you sure?')
      if (del === true) {
        var vm = this
        this.$http.delete('/task_template_collections/' + this.collection.value)
          .then(function (response) {
            vm.deleteSuccessful(response)
            vm.taskTemplateCollectionObject = {}
          })
          .catch(e => {
            console.log(e.response)
            vm.errorMessage = e.response.data
          })
      }
    },
    getTeams () {
      this.$http.get('/teams')
        .then(response => this.setTeams(response))
        .catch(e => { console.log(e.response) })
    },
    setTeams (response) {
      this.teams = response.data.map(function (team) {
        return {text: team.name, value: team.id}
      })
    },
    cloneCollection () {
      this.taskTemplateCollectionObject.name = this.taskTemplateCollectionObject.name + ' clone'
      this.taskTemplateCollectionObject.clone_id = this.taskTemplateCollectionObject.id
      this.taskTemplateCollectionObject.id = null
    },
    submitTaskTemplateCollection () {
      if (this.taskTemplateCollectionObject.id) {
        this.$http.put(
          ('/task_template_collections/' + this.taskTemplateCollectionObject.id), {task_template_collection: this.taskTemplateCollectionObject})
          .then(response => this.submitSuccessful(response.data))
          .catch(e => { console.log(e) })
      } else {
        var vm = this
        this.$http.post(
          ('/task_template_collections'), {task_template_collection: this.taskTemplateCollectionObject})
          .then(function (response) {
            vm.taskTemplateCollectionObject = response.data
            vm.submitSuccessful(response.data)
          })
          .catch(e => { console.log(e) })
      }
    },
    submitSuccessful (data) {
      this.$root.$emit('templateCollectionUpdated', {label: data.name, value: data.id})
      this.submitText = 'Success!'
      var vm = this
      setTimeout(function () {
        vm.submitText = 'Submit'
      }, 3000)
    },
    deleteSuccessful () {
      this.$root.$emit('templateCollectionDeleted')
      this.taskTemplateCollectionObject = {
        name: '',
        team_id: null
      }
    }
  }
}
</script>

<style scoped>
.alert {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/TaskTemplateCollection.vue